<div class="slider">
  <div
    class="slider__container animate"
    (touchstart)="disableSwipe ? null : onTouchStartEvent($event)"
    (touchmove)="onTouchMoveEvent($event)"
    (touchend)="onTouchEndEvent($event)"
  >
    <div class="slider__container__item" *ngFor="let picture of pictures; let i = index">
      <ng-container>
        <vc-images
          lazyOff="true"
          draggable="false"
          [url]="'/produit/' + picture.path"
          [width]="500"
          [alt]="picture.alt"
          (click)="onImageClick.emit(i)"
        ></vc-images>
      </ng-container>
    </div>
  </div>
</div>
